export default "https://assets-v2.scaler.com/packs/files/scaler-coins.ca508e.webp";